export const TwitterIconSmall = () => {
    return (
        <svg
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 21.5615C16.799 21.5615 21.5 16.8605 21.5 11.0615C21.5 5.26253 16.799 0.561523 11 0.561523C5.20101 0.561523 0.5 5.26253 0.5 11.0615C0.5 16.8605 5.20101 21.5615 11 21.5615Z"
                fill="#2E2E2E"
                stroke="white"
            />
            <path
                d="M16.5999 7.58859C16.1801 7.77361 15.7353 7.89571 15.2799 7.95095C15.7602 7.6638 16.1192 7.21113 16.2893 6.678C15.8385 6.94605 15.3451 7.13468 14.8305 7.23565C14.5151 6.90001 14.1062 6.66685 13.6567 6.56637C13.2073 6.46589 12.738 6.50272 12.3097 6.6721C11.8814 6.84148 11.5139 7.1356 11.2548 7.51634C10.9956 7.89707 10.8568 8.34686 10.8564 8.80741C10.8567 8.98394 10.8764 9.15991 10.9152 9.33212C10.0022 9.28751 9.10875 9.0519 8.2925 8.64053C7.47625 8.22916 6.75535 7.65117 6.17635 6.94388C5.88437 7.44825 5.79484 8.04468 5.92589 8.61254C6.05693 9.1804 6.39876 9.6773 6.88223 10.0027C6.51692 9.99116 6.15961 9.89276 5.83988 9.71566V9.74623C5.84029 10.2768 6.0242 10.7909 6.36042 11.2013C6.69665 11.6117 7.16449 11.8932 7.68459 11.998C7.34606 12.0888 6.99146 12.1025 6.64694 12.038C6.79328 12.4947 7.07891 12.8941 7.46376 13.1802C7.8486 13.4663 8.31336 13.6247 8.79282 13.6333C7.97875 14.2699 6.97447 14.6146 5.94106 14.6121C5.75782 14.6119 5.57476 14.6009 5.39282 14.5792C6.44491 15.257 7.67072 15.6157 8.92223 15.6121C13.1575 15.6121 15.4611 12.1109 15.4611 9.07565C15.4611 8.97447 15.4611 8.87564 15.4611 8.77682C15.9081 8.45139 16.2937 8.04905 16.5999 7.58859Z"
                fill="white"
            />
        </svg>
    );
};
